import React, { useState } from 'react';
import { t } from 'ttag';
import { CTA } from '../../../../general/Button';
import TinyModal from '../../../../general/TinyModal';

type WarningProps = {
    show: boolean;
    onHide: () => void;
    // done: the group order is left or cancelled, and the basket cleared
    onConfirm: () => Promise<void> | void;
};

const useBusy = (onConfirm: WarningProps['onConfirm']): [boolean, () => Promise<void>] => {
    const [busy, setBusy] = useState(false);

    return [
        busy,
        async () => {
            setBusy(true);

            try {
                await onConfirm();
            } finally {
                setBusy(false);
            }
        },
    ];
};

// The lead ends the group order for everyone
export const CancelGroupModal = ({ show, onHide, onConfirm }: WarningProps) => {
    const [busy, confirm] = useBusy(onConfirm);

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            modalID="group-cancel-modal"
            header={t`Cancel group order?`}
            footer={
                <>
                    <CTA type="button" secondary buddies onClick={confirm} loading={busy}>
                        <span>{t`Cancel order`}</span>
                    </CTA>
                    <CTA type="button" buddies onClick={onHide}>
                        <span>{t`Keep order`}</span>
                    </CTA>
                </>
            }
        >
            <p>{t`Cancelling ends the group order for everyone. The link will stop working, the basket will be emptied and your guests' items will be lost.`}</p>
        </TinyModal>
    );
};

// A guest takes themselves, and what they added, out of it
export const LeaveGroupModal = ({ show, onHide, onConfirm }: WarningProps) => {
    const [busy, confirm] = useBusy(onConfirm);

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            modalID="group-leave-modal"
            header={t`Leave group order?`}
            footer={
                <>
                    <CTA type="button" secondary buddies onClick={confirm} loading={busy}>
                        <span>{t`Leave order`}</span>
                    </CTA>
                    <CTA type="button" buddies onClick={onHide}>
                        <span>{t`Stay here`}</span>
                    </CTA>
                </>
            }
        >
            <p>{t`Leaving removes the items you added from the group order and empties your basket.`}</p>
        </TinyModal>
    );
};
